import {
  FETCHING_STATS_SUMMARY,
  FETCHING_STATS_SUMMARY_SUCCESS,
  FETCHING_STATS_SUMMARY_FAILED,
  LOGGING_OUT_SUCCESS,
} from '../../utils/types';

const initialState = {
  // { active_forms, total_responses, date_range: { start_date, end_date } }
  // null until the first fetch resolves (or on failure)
  summary: null,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGGING_OUT_SUCCESS:
      return {
        ...initialState,
      };
    case FETCHING_STATS_SUMMARY:
      return {
        ...state,
        loading: true,
      };
    case FETCHING_STATS_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.data,
        loading: false,
      };
    case FETCHING_STATS_SUMMARY_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
